var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.333 18.917h-6.25v-6.25a2.083 2.083 0 10-4.166 0V21c0 1.152.933 2.083 2.083 2.083h8.333A2.081 2.081 0 0031.417 21a2.081 2.081 0 00-2.084-2.083zM21 37.667C11.81 37.667 4.333 30.19 4.333 21 4.333 11.81 11.81 4.333 21 4.333c9.19 0 16.667 7.477 16.667 16.667 0 9.19-7.477 16.667-16.667 16.667zm0-37.5C9.513.167.167 9.513.167 21 .167 32.488 9.513 41.833 21 41.833c11.488 0 20.833-9.345 20.833-20.833C41.833 9.513 32.488.167 21 .167z",
    fill: "#FFF"
  })));
}

export default SvgClockWhite;